export default __webpack_public_path__ + "static/media/rearrange.4c95de35.svg";